/* eslint-disable */
<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_EMPLOYEES } from '@/store/types';
import employeesApi from '@/services/apis/admin/employees.api';

export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 10,
    },
    keyword: {
      type: String,
      default: '',
    },
    employer_id: {
      type: String,
      default: null,
    },
    order_by: {
      type: String,
      default: null,
    },
    order_direction: {
      type: String,
      default: null,
    },
    start_date: {
      type: String,
      default: null,
    },
    end_date: {
      type: String,
      default: null,
    },
    all: {
      type: Boolean,
      default: false,
    },
    with_credits: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = employeesApi.useEmployeesQuery({
      page: props.page,
      per_page: props.per_page,
      keyword: props.keyword,
      employer_id: props.employer_id,
      order_by: props.order_by,
      order_direction: props.order_direction,
      start_date: props.start_date,
      end_date: props.end_date,
      all: props.all,
      with_credits: props.with_credits,
    });
    if (query.value) {
      store.commit(ADMIN_EMPLOYEES.SET_EMPLOYEES_QUERY, query);
    }
    return { query };
  },
};
</script>
